// extracted by mini-css-extract-plugin
export default {"sectionHeading":"SectionHeading_sectionHeading__zi9Ed","logo":"SectionHeading_logo__IIf5S"};